document.addEventListener('submit', async (e) => {

    if (e.target.id === 'formCrearPersonal') {

        e.preventDefault();
        const formulario = e.target;
        const modalPadre = formulario.closest('.modal');
        const btnSubmit = formulario.querySelector('#btnCrearPersonal');
        const spinner = formulario.querySelector('#spinner');
        const formData = new FormData(formulario);
        
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));

        try {
            const respuesta = await fetch('/api/personal/crear', {
                method: 'POST',
                body: formData
            });
            
            const json = await respuesta.json();
            const status = respuesta.status;
            const resultado = json.result;
            
            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                window.location.href = "/personal";
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
            } 
            if (!resultado.hayErrores) {

                formulario.reset();
                
                if (modalPadre) modalPadre.classList.remove('modal--show');

                if (window.location.pathname === "/personal") {
                    if (typeof window.actualizarTablaPersonal === 'function') {
                        window.actualizarTablaPersonal();
                    }
                }
                lanzarAlerta("Registro guardado con éxito.", "alerta-verde");
            }

        } catch (error) {
            console.error("Error:", error);
            alert("Error crítico al procesar la solicitud, contactar al Administrador.");
            window.location.href = "/inyeccion";
        } finally {
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});